module.exports = __webpack_public_path__ + "static/media/document_upload_active.d064c578.svg";